const MenuReducer = (state, action) => {
	switch (action.type) {
		case "SHOW": {
			return {
				mobileMenu: true,
			};
		}
		case "HIDE": {
			return {
				mobileMenu: false,
			};
		}
		case "TOGGLE": {
			return {
				mobileMenu: !state.mobileMenu,
			};
		}
	}
};

export default MenuReducer;
